import type { IPhoto } from 'src/interfaces';

export const sortPhotos = (photos: IPhoto[]) => {
  const coverIndex = Math.max(
    photos.findIndex(({ cover }) => !!cover),
    0
  );

  if (!coverIndex) {
    return photos;
  }

  const images = [...photos];
  const [coverImage] = images.splice(coverIndex, 1);
  return [coverImage, ...images];
};
